export default __webpack_public_path__ + "static/media/gallery-30.e5dda7ad.jpg";